import { z } from "zod";

// ── Comment Response ──

export const CommentResponseSchema = z.object({
    id: z.uuid(),
    list_id: z.uuid(),
    author_id: z.uuid(),
    author_name: z.string(),
    content: z.string(),
    created_at: z.string(),
});
export type CommentResponse = z.infer<typeof CommentResponseSchema>;

// ── Create Comment ──

export const CreateCommentRequestSchema = z.object({
    list_id: z.uuid(),
    content: z.string().min(1),
});
export type CreateCommentRequest = z.infer<typeof CreateCommentRequestSchema>;

// ── Wrappers ──

export const CommentListResponseSchema = z.object({
    success: z.boolean(),
    data: z.array(CommentResponseSchema),
});
export type CommentListResponse = z.infer<typeof CommentListResponseSchema>;
